import { TabularCopySink } from './tabular.copysink';
import { Metamodel } from 'app/model/base/model';
import { IAttribute, IModel } from 'app/model/base/annotation';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { GoogleBigQueryObjectV2Dataset } from 'app/model/dataset/google-bigquery-v2.dataset';

@Metamodel.model({
    name: adfModelTypeMap.googleBigQuery.copySinkType,
    display: [],
    referable: true,
    tags: { datasetModel: [Metamodel.modelFor(GoogleBigQueryObjectV2Dataset)] }
})
export class GoogleBigQueryV2CopySink extends TabularCopySink {
    public static readonly MODEL: IModel;
     public static readonly WRITE_BEHAVIOR: IAttribute;
    constructor(name?: string, description?: string, id?: number) {
        super(name, description, id);
        this.writeBatchTimeout = '00:30:00';
        this.writeBatchSize = 10000;
    }

    @Metamodel.attribute({
        templatable: true,
        association: 'WRITE_BEHAVIOR',
        display: stringResources.ModelName_WriteBehavior
    })
    public writeBehavior: 'insert' | 'upsert' = 'insert';
}
